import anime from 'animejs'

const gridAnimObj = {
    el: null,
    items: null,
    timeline: null
}

const reduceAnimation = '(prefers-reduced-motion: reduce)'
const delay = 1100
const duration = 850
const offset = delay

export function GridAnim() {
    const elements = document.querySelectorAll('.js-square-grid-anim')
    return Array.from(elements).forEach(createObj)
}

function createObj(el) {
    const Obj = Object.create(gridAnimObj)
    init.call(Obj, el)
    return Obj
}

function init(el) {
    if (!el) {
        return
    }

    this.el = el
    this.items = Array.from(this.el.children).map((el) => {
        return {
            el,
            images: Array.from(el.children),
            pos: 1
        }
    })

    this.timeline = anime.timeline({
        delay: delay,
        duration: duration,
        loop: true,
        autoplay: true,
        easing: 'cubicBezier(0.3, 0.15, 0.18, 1)'
    })

    if (window.matchMedia(reduceAnimation).matches) {
        return
    }

    let hasMore = true
    let itemsPos = 0
    let imagePos = 1
    let itemLength = this.items.length
    let maxImagesLength = this.items.map((el) => el.images.length)
    maxImagesLength = Math.max.apply(null, maxImagesLength)

    if (!maxImagesLength) {
        return
    }

    while (hasMore) {
        const item = this.items[itemsPos]
        const image = item.images[imagePos]
        let calcOffset = offset

        if (image) {
            this.timeline.add(
                {
                    targets: image,
                    opacity: [0, 1]
                },
                '-=' + calcOffset
            )
        } else if (imagePos === item.images.length) {
            this.timeline.add(
                {
                    targets: item.images.slice(1),
                    opacity: [1, 0]
                },
                '-=' + calcOffset
            )
        }

        itemsPos++
        itemsPos = itemsPos % itemLength
        if (itemsPos === 0) {
            imagePos++

            if (imagePos > maxImagesLength) {
                hasMore = false
            }
        }
    }
}
